import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Avatar as Avataaars } from "react-avataaars";
import { AVATAR_DEFAULT_SIZE } from "./constants";
import { buildAvatarOptions } from "./config";

export const Avatar = forwardRef(function Avatar(
	{ dna, size = AVATAR_DEFAULT_SIZE, className, ariaLabel = "avatar" },
	ref,
) {
	const wrapperRef = useRef(null);
	useImperativeHandle(ref, () => wrapperRef.current);
	const options = buildAvatarOptions(dna);
	const hash = JSON.stringify(options);

	return (
		<div ref={wrapperRef} className={className} aria-label={ariaLabel}>
			<Avataaars options={options} size={size} hash={hash} />
		</div>
	);
});
